import { UserGroupItem } from "./UserGroupItem";

export default UserGroupItem;
